import { render, staticRenderFns } from "./ad-preview-placement-table.vue?vue&type=template&id=7742f9de&scoped=true&"
import script from "./ad-preview-placement-table.vue?vue&type=script&lang=js&"
export * from "./ad-preview-placement-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7742f9de",
  null
  
)

export default component.exports